import React from 'react'
import { Image, Heading, Box } from 'rebass'
import { Link } from 'gatsby'
import typography from '../../utils/typography'
import SearchHero from './components/SearchHero'
import SearchGroupResultRow from './components/SearchGroupResultRow'
import CategoryBadge from './components/CategoryBadge'
import ColumnImage from './components/ColumnImage'
import ColumnDescription from './components/ColumnDescription'
import ArrowRight from './components/ArrowRight'
import SearchGroupHeading from './components/SearchGroupHeading'
import SearchResults from './components/SearchResults'
import highlight from '../../lib/highlighter'

const SearchResult = ({ searchTerm, imageUrl, category, text, url }) => {
  let ResultImageOrCategoryFallBack = (
    <CategoryBadge px={10} mx={0}>
      {category}
    </CategoryBadge>
  )

  if (imageUrl) {
    ResultImageOrCategoryFallBack = <Image src={`${imageUrl}`} />
  }

  return (
    <Link to={url}>
      <SearchGroupResultRow>
        <ColumnImage width={[5 / 18, 2 / 12]}>
          {ResultImageOrCategoryFallBack}
        </ColumnImage>
        <ColumnDescription
          f={[3, null, 4]}
          width={[11 / 18, 9 / 12]}
          py={30}
          pr={10}
        >
          <span
            dangerouslySetInnerHTML={{
              __html: highlight(searchTerm, text)
            }}
          />
        </ColumnDescription>
        <Box width={[1 / 18, 1 / 12]} pr={'3.5%'}>
          <ArrowRight />
        </Box>
      </SearchGroupResultRow>
    </Link>
  )
}

class ContentOmniSearchResults extends React.Component {
  render() {
    const groups = this.props.results
    const searchHeadingPreText =
      Object.keys(groups).length > 0 ? 'Displaying' : 'No'
    return (
      <Box>
        <SearchHero
          pt={[typography.rhythm(1.25), null, typography.rhythm(2.5)]}
          pb={[typography.rhythm(0.5), null, typography.rhythm(1.25)]}
        >
          <Heading as="h3" fontSize={[5, 6, 7]} textAlign="center">
            {searchHeadingPreText} search results for:{' '}
            <strong>{this.props.searchTerm}</strong>
          </Heading>
        </SearchHero>
        <SearchResults>
          {Object.keys(groups).map((group, groupIndex) => {
            const results = groups[group]
            return (
              <Box key={`sr:${group}:${groupIndex}`}>
                <SearchGroupHeading
                  fontSize={[3, null, 4]}
                  pl={[20, null, 0]}
                  pt={typography.rhythm(1.25)}
                  pb={typography.rhythm(0.75)}
                >
                  {group}
                </SearchGroupHeading>
                {results.map((result, i) => (
                  <SearchResult
                    searchTerm={this.props.searchTerm}
                    key={`${group}:${i}`}
                    {...result}
                  />
                ))}
              </Box>
            )
          })}
        </SearchResults>
      </Box>
    )
  }
}

export default ContentOmniSearchResults
